import type { PayloadAction} from "@reduxjs/toolkit";
import {createSlice} from "@reduxjs/toolkit";
import type {RootState} from "@/store";
import type {EmailCampaignAiRewriteSource} from "@Libraries/ai-email-campaign-content-library";
import type {RedesignIssue} from "@Components/ai-resdesign-prompt-box/ai-redesign-prompt-box.types";

type ComponentId = string;
type LoadingComponents = Record<ComponentId, boolean>;
type RewriteIssues = Record<ComponentId, SourceRewriteIssue>;
interface SourceRewriteIssue {
    source: EmailCampaignAiRewriteSource;
    issue: RedesignIssue
}

interface StateProps {
    loadingComponents: LoadingComponents;
    rewriteIssues: RewriteIssues;
}

const initialState: StateProps = {
    loadingComponents: {},
    rewriteIssues: {},
};

const emailMakerAiRewritePromptBoxSlice = createSlice({
  name: 'emailMakerAiRewritePromptBox',
  initialState,
  reducers: {
    addLoadingComponent(state, action: PayloadAction<string>) {
      const componentID = action.payload;
      state.loadingComponents[componentID] = true;
    },
    removeLoadingComponent(state, action: PayloadAction<string>) {
      const componentID = action.payload;
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete state.loadingComponents[componentID];
    },
    addRewriteIssue(state, action: PayloadAction<{componentId: string; source: EmailCampaignAiRewriteSource; issue: RedesignIssue}>) {
        const {componentId, source, issue} = action.payload;
        state.rewriteIssues[componentId] = {
            source,
            issue,
        };
    },
  removeRewriteIssue(state, action: PayloadAction<string>) {
    const componentID = action.payload;
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete state.rewriteIssues[componentID];
  }
  },
});

export const {addLoadingComponent, removeLoadingComponent, addRewriteIssue, removeRewriteIssue} = emailMakerAiRewritePromptBoxSlice.actions;
export const emailMakerAiRewritePromptBoxReducer = emailMakerAiRewritePromptBoxSlice.reducer;

export const isComponentLoading = (state: RootState, componentId: string): boolean => {
    return Boolean(state.emailMakerAiRewritePromptBox.loadingComponents[componentId]);
};

export const getRewriteIssue = (state: RootState, componentId: string, source: EmailCampaignAiRewriteSource): RedesignIssue | undefined => {
    const entry = state.emailMakerAiRewritePromptBox.rewriteIssues[componentId];
    if (!entry || entry.source !== source) {
        return undefined;
    }

    return entry.issue;
}